import { Tooltip } from 'antd';
import './style.scss';
import { useMediaQuery } from 'react-responsive';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Icons from '../../../../configs/icon.config';
import { authState } from '../../../../app/auth/authSlice';

interface FeedbackButtonProps {
  handleClick?: any;
}

function FeedbackButton({ handleClick }: FeedbackButtonProps) {
  const { t } = useTranslation();
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const { profile } = useSelector(authState);
  const feedbackSwitch = profile?.application_settings?.find(
    (item: any) => item.key_name === 'feedback'
  );
  return (
    <div>
      {feedbackSwitch?.bool_value && !isMobile && (
        <Tooltip placement="left" title={t('feedback.tooltip')}>
          <button onClick={handleClick} className="feedback-button flex z-50">
            <span className="mr-2.5 mt-2">{Icons.pencilSquare}</span>
            <span className="rotated-text text-bold text-[15px]">
              {' '}
              {t('feedback.button')}
            </span>
          </button>
        </Tooltip>
      )}
    </div>
  );
}

export default FeedbackButton;
